import React from "react";
import { Home } from "./pages/Home";
import "./assets/variables.scss";
import "./assets/global.scss";

function App() {
  return <Home />;
}

export default App;
